import React, { useEffect, useRef } from "react";
import { MathfieldElement } from "mathlive"; // Import the Mathlive element
import "./MathInputField.css";

const MathInputField = ({
  value = "",
  onChange,
  editable = true,
  placeholder = "Type here...",
}) => {
  const mathFieldRef = useRef(null);

  useEffect(() => {
    const mathField = mathFieldRef.current;

    if (mathField) {
      // Configure mathlive for better cross-browser compatibility
      mathField.setOptions({
        virtualKeyboardMode: "manual", // Enable virtual keyboard
        virtualKeyboards: "all", // Show all virtual keyboards
        smartFence: true,
        smartSuperscript: true,
        removeExtraneousParentheses: true,
        // Ensure keyboard works on mobile
        virtualKeyboardLayout: "auto",
        // Enable touch events for mobile
        virtualKeyboardToggle: "manual",
      });

      // Set the initial value
      mathField.value = value;

      // Set editable or read-only mode
      mathField.readOnly = !editable;

      if (editable) {
        // Handle input changes when editable
        const handleInput = () => {
          onChange(mathField.value); // Pass the updated value to the parent component
        };
        mathField.addEventListener("input", handleInput);

        // Cleanup event listener on unmount
        return () => {
          mathField.removeEventListener("input", handleInput);
        };
      }
    }
  }, [value, editable, onChange]);

  return (
    <math-field
      ref={mathFieldRef}
      style={{
        border: editable ? "1px solid #ccc" : "none",
        padding: editable ? "10px" : "0px",
        borderRadius: editable ? "4px" : "0px",
        width: "100%",
        minHeight: "50px",
        boxSizing: "border-box",
        background: editable ? "#fff" : "transparent",
        fontSize: "16px",
      }}
      placeholder={editable ? placeholder : ""}
      virtual-keyboard-toggle
    ></math-field>
  );
};

export default MathInputField;
